
import Vue from 'vue';
import LoginCard from '@/components/common/LoginCard.vue';
import { LoginForm } from '@/interfaces/loginInfo';
import SiteSelect from '@/components/common/SiteSelect.vue';
import { Client, Site } from '@/interfaces/multiTenancy';
import router from '@/router';
import permissions from '@/lib/permissions';
import { User } from '@/interfaces/userInfo';

interface Tenancies {
	client: Client;
	site: Site;
}

export default Vue.extend({
	components: {
		LoginCard,
		SiteSelect,
	},

	data() {
		return {
			statusMessage: '',
		} as {
			statusMessage: string;
		};
	},

	computed: {
		loggedInUser(): User {
			return this.$store.getters['usermanagement/user/getUser'];
		},

		clients(): Client[] {
			return this.$store.getters['tenancy/clients/getClients'];
		},

		sites(): Site[] {
			return this.$store.getters['tenancy/sites/getSites'];
		},
	},

	methods: {
		async submitForm(form: LoginForm) {
			this.$store.dispatch('tools/loading/changeLoadingStatus');
			try {
				this.statusMessage = '';

				await this.$store.dispatch('usermanagement/authentication/logIn', {
					loginForm: {
						username: form.username,
						password: form.password,
					},
				});
			} catch (error) {
				this.statusMessage = (error as Error).message;
			}
			this.$store.dispatch('tools/loading/changeLoadingStatus');
		},

		async submitTenancies(tenancies: Tenancies) {
			if (tenancies && tenancies.client && tenancies.site) {
				const client = tenancies.client;
				const site = tenancies.site;

				this.$store.dispatch('tools/loading/changeLoadingStatus');
				router.push({ name: 'DashBoard' }).catch(() => true);
				await Promise.all([
					this.$store.dispatch('tenancy/clients/selectClient', { client: client }),
					this.$store.dispatch('tenancy/sites/selectSite', { site: site }),
					this.$store.dispatch('usermanagement/authentication/getSiteSpecificToken', {
						clientId: client.id,
						siteId: site.id,
					}),
				]);

				await this.$store.dispatch('fetchAllData');
				this.$store.dispatch('usermanagement/user/setUserRole', {
					userRole: permissions.checkUserRole(
						this.loggedInUser,
						this.$store.getters['types/roles/getRoles'],
						site
					),
				});
				this.$store.dispatch('tools/loading/changeLoadingStatus');
			}
		},
	},
});
